

export class HasPermissionsInput {

    permissions: string[] = [];
    any: boolean = false;
    
    constructor(i?: Partial<HasPermissionsInput>) {
        Object.assign(this, i);
    }

}